export class GeographicalBoundary {
  alternativeCode!: string;
  name!: string;
  parentTypeId!: string;
}
